import { render } from "./DraftOverview.vue?vue&type=template&id=7c71fecc&scoped=true"
import script from "./DraftOverview.vue?vue&type=script&lang=js"
export * from "./DraftOverview.vue?vue&type=script&lang=js"

import "./DraftOverview.vue?vue&type=style&index=0&id=7c71fecc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c71fecc"]])

export default __exports__